export const perPage = 10;
export const descriptionText = 42;